module.exports = __webpack_public_path__ + "img/AroundMe.0b2aa224.svg";